import { UniverseReference } from '@front/common/src/types/commons';

import { SignupStep } from '../hooks/use-signup-stepper';

import { SignupAccount } from './pro';

export type LogSignupEventType = 'SignupPageViewed' | 'SignupQualified' | 'SignupDisqualified';

export const SIGNUP_PAGE_VIEWED = 'SignupPageViewed';
export const SIGNUP_PAGE_QUALIFIED = 'SignupQualified';
export const SIGNUP_PAGE_DISQUALIFIED = 'SignupDisqualified';

export type LogSignupStepEventProps = {
  account?: Partial<SignupAccount>;
  step: SignupStep;
  universe?: UniverseReference;
};

export type LogSignupConfirmationProps = {
  isQualified: boolean;
  universe?: UniverseReference;
  account: {
    company_status: SignupAccount['company_status'];
    declarative_source: SignupAccount['declarative_source'];
  } & Partial<{
    weekly_hours: SignupAccount['weekly_hours'];
    also_a_nanny: SignupAccount['also_a_nanny'];
    nova_status: SignupAccount['nova_status'];
  }>;
};

export type StepName = 'RevenueSimulator' | 'Identity' | 'Company' | 'Availability' | 'Appointment' | 'Confirmation';

const stepNameByRoutePath: Record<SignupStep, StepName | undefined> = {
  confirmation: 'Confirmation',
  not_qualified: undefined,
  revenue_simulator: 'RevenueSimulator',
  register: 'Identity',
  pro_status: 'Company',
  additional_information: 'Availability',
  appointment: 'Appointment',
};

export const buildEventPropertiesForStepEventTracking = ({ account, step, universe }: LogSignupStepEventProps) => ({
  step: stepNameByRoutePath[step],
  universe,
  professional_type: account?.company_status,
  nova: account?.nova_status,
  work_availability: account?.weekly_hours,
  nany: account?.also_a_nanny,
  nany_shift_type: account?.childcare_availability,
});
